/** Scanner encodes hyphens as ½; normalize before board-mission QR API calls. */
export const normalizeBoardMissionBarcode = (barcode: string): string =>
  barcode.replace(/½/g, "-");

/** ERP may return null, undefined, or "" for productType on direct QR responses. */
export const normalizeRowProductType = (
  productType?: string | null
): string => {
  if (productType == null) {
    return "";
  }
  return String(productType).trim();
};

/**
 * Row lock key. When productType is empty, key is boardMissionId only so UI
 * can match board rows regardless of their productType field.
 */
export const boardMissionRowKey = (
  boardMissionId: string,
  productType?: string | null
): string => {
  const id = String(boardMissionId);
  const pt = normalizeRowProductType(productType);
  return pt ? `${id}__${pt}` : id;
};
